import React, { Component } from "react";
import axios from 'axios';

// import ViewNavigationV2 from './ViewNavigationV2.js';
import ViewPanelV3 from './ViewPanelV3.js';

import * as Constants from "./Constants.js";

import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const queryString = require('query-string');

const convert = require('xml-js');

class ViewV2 extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      brandTitle: "epilogos Search",
      brandSubtitle: "perform motif discovery for chromatin state sequences",
      viewPanelKey: Date(),
      dataState: "loading",
      dataStateMessage: "loading data",
      description: "",
      htmlURL: "",
      textURL: "",
      xmlURL: "",
      archiveURL: "",
      metadataURL: "",
      uuid: "",
      memeXML: "",
      memeJSON: null,
      memeJSONText: "",
      memeDataAvailable: false,
      memeTrainingSequences: null,
      memeMotifs: null,
      jobMetadata: null,
    };
    this.refreshTimerID = null;
  }
  
  componentDidMount() {
    this.initializeRefreshTimer();
    let query = queryString.parse(window.location.search);
    this.queryForMemeData();
  }
  
  queryForMemeData = () => {
    let query = queryString.parse(window.location.search);
    if ('id' in query) {
      let self = this;
      console.log(`retrieving job for ID ${query.id}`);
      axios.post('../assets/services/retrieveJob.py', { id : query.id })
        .then(function(jobMetadataPostResponse) {
          const jobMetadata = jobMetadataPostResponse.data;
          const assembly = jobMetadata.genome;
          const model = Constants.epilogosMemeModelsForGenomes[jobMetadata.genome][jobMetadata.stateModel].model;
          //console.log("jobMetadata", jobMetadata);
          const metadataURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/job_metadata.json';
          const htmlURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/meme.html';
          const textURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/meme.txt';
          const xmlURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/meme.xml';
          const archiveURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/epilogos-meme.' + jobMetadata['id'] + '.tbz2';
          //
          // check if meme.html exists (200); proceed load state data if so, else set view panel content to something else
          //
          axios.get(xmlURL)
            .then(function(xmlURLGetResponse) {
              const memeXML = xmlURLGetResponse.data;
              let memeJSON = null;
              try {
                memeJSON = convert.xml2js(memeXML, {compact: true, spaces: 2});  
                //console.log("convert.xml2js memeJSON", memeJSON);
              }
              catch (xmlURLConvertError) {
                console.error("convert.xml2js error", xmlURLConvertError);
              }              
              self.setState({
                dataStateMessage: "processing data",
                assembly: assembly,
                model: model,
                uuid : jobMetadata['id'],
                description : jobMetadata['description'],
                jobMetadata: jobMetadata,
              }, () => {
                /*
                  Process MEME XML into data object
                */
                if ((typeof memeJSON === 'undefined') || (memeJSON === null)) {
                  self.setState({
                    description : "",
                    dataState: "invalid",
                    viewPanelKey : Date(),
                  });
                  return;
                }
                const memeTrainingSequenceIds = memeJSON.MEME.training_set.sequence.map(d => d._attributes.id);
                const memeTrainingSequenceNames = memeJSON.MEME.training_set.sequence.map(d => d._attributes.name);
                const memeTrainingSequenceLengths = memeJSON.MEME.training_set.sequence.map(d => d._attributes.length);
                const memeTrainingSequences = memeTrainingSequenceNames.reduce(function(result, field, index) {
                  result[memeTrainingSequenceIds[index]] = { 
                    index: index, 
                    name: field,
                    length: memeTrainingSequenceLengths[index]
                  };
                  return result;
                }, {});
                const memeJSONAsText = JSON.stringify(memeJSON, null, 2);
                const memeMotifs = self.memeMotifsFromJSON(memeJSON, memeTrainingSequences);
                let fimoManifest = null;
                /* 
                  Look for FIMO manifest
                */
                axios.post('../assets/services/retrieveFimoManifest.py', { id : jobMetadata['id'] })
                  .then(function(response) {
                    /* do stuff with FIMO manifest */
                    fimoManifest = response.data;
                  })
                  .catch(function(error) {
                    /* deal with non-400 or non-404 error */
                    if ((parseInt(error.response.status) !== 400) && (parseInt(error.response.status) !== 404)) {
                      console.log("error.response.status", error.response.status);
                      console.log("ViewV3 retrieveFimoManifest error", JSON.stringify(error, null, 2));
                    }
                  })
                  .finally(function() {
                    /*
                      Get metadata attributes
                    */
                    self.setState({
                      dataState : "valid",
                      htmlURL : htmlURL,
                      textURL: textURL,
                      xmlURL: xmlURL,
                      archiveURL : archiveURL,
                      metadataURL : metadataURL,
                      viewPanelKey : Date(),
                      memeXML: memeXML,
                      memeJSON: memeJSON,
                      memeJSONText: memeJSONAsText,
                      memeDataAvailable: true,
                      memeTrainingSequences: memeTrainingSequences,
                      memeMotifs: memeMotifs,
                      fimoManifest: fimoManifest,
                    });
                  });
              })
            })
            .catch(function(xmlURLGetError) {
              self.setState({
                description : "",
                dataState : "invalid",
                viewPanelKey : Date()
              })
            });
        })
        .catch (function(jobMetadataPostError) {
          console.log(jobMetadataPostError);
          if (jobMetadataPostError.response) {
            console.log(JSON.stringify(jobMetadataPostError.response.data));
            console.log(jobMetadataPostError.response.status);
            console.log(jobMetadataPostError.response.headers);
            switch (jobMetadataPostError.response.status) {
              case 400:
              case 403:
              case 404:
                self.setState({
                  description : "",
                  dataState : "invalid",
                  viewPanelKey : Date()
                })
                break;
              default:
                break;
            }
          }
        });
    }
  }
  
  componentWillUnmount() {
    window.clearInterval(this.refreshTimerID);
  }

  initializeRefreshTimer = () => {
    let self = this;
    if (!self.state.memeDataAvailable) {
      this.refreshTimerID = setInterval(() => {
        if (self.state.memeDataAvailable) {
          window.clearInterval(this.refreshTimerID);
        }
        else {
          this.queryForMemeData();
        }
      }, Constants.epilogosMemeViewRefreshTimer);
    }
  }

  memeMotifsFromJSON = (o, ts) => {
    //console.log("memeMotifsFromJSON", JSON.stringify(o, null, 2));
    //let self = this;
    
    let items = [];
    let attributes = [];
    let sites = [];
    let sequences_id_to_attr = {};
    let motifs_id_to_attr = {};
    /*
      Version
    */
    if (!o.MEME || !o.MEME._attributes || !o.MEME._attributes.version) {
      throw new Error("MEME object lacks version attribute");
    }
    const memeVersion = o.MEME._attributes.version;
    if (!o.MEME || !o.MEME.training_set || !o.MEME.training_set.alphabet || !o.MEME.training_set.alphabet.letter) {
      throw new Error("MEME object does not define alphabet array");
    }
    
    /*
      Assembly
    */
    const assembly = this.state.assembly;
    
    /*
      Model
    */
    const model = this.state.model;
    
    /*
      Alphabet
    */
    let alphabet = [];
    const alphabetLength = o.MEME.training_set.alphabet.letter.length - 1;
    o.MEME.training_set.alphabet.letter.forEach((l, i) => {
      if (i < alphabetLength) {
        if (!l._attributes || !l._attributes.symbol) {
          throw new Error("MEME object alphabet array element lacks attributes or symbol");
        }
        alphabet.push(l._attributes.symbol);
      }
    });
    const memeAlphabet = alphabet.join('');
    
    /*
      Sequences
       +
      Background frequencies
    */
    if (!o.MEME || !o.MEME.model || !o.MEME.model.background_frequencies || !o.MEME.model.background_frequencies._attributes || !o.MEME.model.background_frequencies._attributes.source) {
      throw new Error("MEME object lacks background frequency source path");
    }
    const memeBackgroundFrequencyPath = o.MEME.model.background_frequencies._attributes.source;
    if (!o.MEME || !o.MEME.training_set || !o.MEME.training_set.sequence || !o.MEME.training_set.letter_frequencies || !o.MEME.training_set.letter_frequencies.alphabet_array || !o.MEME.training_set.letter_frequencies.alphabet_array.value) {
      throw new Error("MEME object lacks background frequencies");
    }
    o.MEME.training_set.sequence.forEach((s, si) => {
      sequences_id_to_attr[s._attributes.id] = {
        index: si,
        name: s._attributes.name,
        length: parseInt(s._attributes.length),
        weight: parseFloat(s._attributes.weight)
      };
    });
    //console.log("sequences_id_to_attr", JSON.stringify(sequences_id_to_attr, null, 2));
    let backgroundFrequencies = [];
    o.MEME.training_set.letter_frequencies.alphabet_array.value.forEach((f) => {
      if (!f._attributes || !f._attributes.letter_id || !f._text) {
        throw new Error("MEME object lacks background frequency information for residue");
      }
      backgroundFrequencies.push(f._attributes.letter_id);
      backgroundFrequencies.push(f._text);
    });
    const memeBackgroundFrequencies = backgroundFrequencies.join(' ');
    
    /*
      Motifs
    */
    if (!o.MEME || !o.MEME.motifs || !o.MEME.motifs.motif) {
      throw new Error("MEME object does not define motifs array");
    }
    /*
      Ensure motif is encased in an Array, if it is a single Object
    */
    if (typeof o.MEME.motifs.motif[0] === 'undefined') {
      const motifDeepCopy = JSON.parse(JSON.stringify(o.MEME.motifs.motif));
      o.MEME.motifs.motif = [ motifDeepCopy ];
    }
    //console.log(`o.MEME.motifs.motif ${JSON.stringify(o.MEME.motifs.motif)}`);

    // console.log(`type ${typeof o.MEME.motifs.motif[0]}`);
    // console.log(`length ${JSON.stringify(Object.keys(o.MEME.motifs.motif).length)}`);
    // console.log(`o.MEME.motifs ${JSON.stringify(o.MEME.motifs)}`);

    o.MEME.motifs.motif.forEach((m, mi) => {
      /*
        Attributes
      */
      if (!m._attributes || !m._attributes.id || !m._attributes.name || !m._attributes.alt || !m._attributes.width || !m._attributes.sites || !m._attributes.e_value || !m._attributes.llr || !m._attributes.ic || !m._attributes.re) {
        throw new Error(`MEME object motif instance lacks required attributes ${JSON.stringify(Object.keys(m), null, 2)}`);
      }
      const memeMotifId = m._attributes.id;
      const memeMotifName = m._attributes.name;
      const memeMotifAlt = m._attributes.alt;
      const memeMatrixW = m._attributes.width;
      const memeMatrixALength = memeAlphabet.length;
      const memeMatrixNSites = m._attributes.sites;
      const memeMatrixEValue = m._attributes.e_value;
      const memeMotifLogLikelihoodRatio = m._attributes.llr;
      const memeMotifInformationContent = m._attributes.ic;
      const memeMotifRelativeEntropy = m._attributes.re;
      const memeMotifBayesThreshold = m._attributes.bayes_threshold;
      motifs_id_to_attr[memeMotifId] = {
        idx : mi,
        name : memeMotifName, 
        alt : memeMotifAlt, 
      };
      attributes.push({
        id: memeMotifId,
        name: memeMotifName,
        alt: memeMotifAlt,
        width: memeMatrixW,
        aLength: memeMatrixALength,
        sites: memeMatrixNSites,
        e_value: memeMatrixEValue,
        log_likelihood_ratio: memeMotifLogLikelihoodRatio,
        information_content: memeMotifInformationContent,
        relative_entropy: memeMotifRelativeEntropy,
        bayes_threshold: memeMotifBayesThreshold
      });      
      /*
        Probabilities
      */
      if (!m.probabilities || !m.probabilities.alphabet_matrix || !m.probabilities.alphabet_matrix.alphabet_array) {
        throw new Error("MEME object motif instance lacks required letter-probability matrix array");
      }
      let memeMatrixFrequencies = "";
      m.probabilities.alphabet_matrix.alphabet_array.forEach((fs, fsi) => {
        if (!fs.value) {
          throw new Error("MEME object letter-probability matrix array instance lacks value data");
        }
        fs.value.forEach((f, fi) => {
          if (!f._text) {
            throw new Error("MEME object letter-probability matrix array instance lacks frequency for value instance");
          }
          memeMatrixFrequencies += ` ${f._text} `;
        });
        memeMatrixFrequencies += '\n';
      })
      /*
        Contributing sites
      */
      let memeMotifContributingSites = [];
      if (!m.contributing_sites || !m.contributing_sites.contributing_site) {
        throw new Error("MEME object motif instance lacks contributing site data");
      }
      m.contributing_sites.contributing_site.forEach((cs, csi) => {
        if (!cs._attributes || !cs._attributes.sequence_id || !cs._attributes.position || !cs._attributes.strand || !cs._attributes.pvalue) {
          throw new Error("MEME object motif's contributing site lacks needed attributes");
        }
        if (!cs.left_flank || !cs.site || !cs.site.letter_ref || !cs.right_flank) {
          throw new Error("MEME object motif's contributing site lacks needed flank and site data");
        }
        const site_letters = cs.site.letter_ref.map(d => d._attributes.letter_id);
        const site_sequence = site_letters.join('');
        //console.log("ts", JSON.stringify(ts, null, 2));
        //console.log("ts[cs._attributes.sequence_id]", cs._attributes.sequence_id, ts[cs._attributes.sequence_id]);
/*
        sequences_id_to_attr[cs._attributes.sequence_id] = {
          index: ts[cs._attributes.sequence_id].index,
          name: ts[cs._attributes.sequence_id].name,
          length: ts[cs._attributes.sequence_id].length
        };
*/
        memeMotifContributingSites.push({
          index: csi,
          sequence_id: cs._attributes.sequence_id,
          sequence_name: ts[cs._attributes.sequence_id].name,
          sequence_index: ts[cs._attributes.sequence_id].index,
          position: cs._attributes.position,
          strand: cs._attributes.strand,
          p_value: cs._attributes.pvalue,
          left_flank: (cs.left_flank._text) ? cs.left_flank._text : "",
          sites: site_sequence,
          right_flank: (cs.right_flank._text) ? cs.right_flank._text : ""
        });
      });
      sites.push(memeMotifContributingSites);
      /*
        Items (for react-seqlogo <SequenceLogo items=... />)
      */
      items.push(`MEME version ${memeVersion}

ALPHABET= ${memeAlphabet}

Background letter frequencies (from ${memeBackgroundFrequencyPath}):
${memeBackgroundFrequencies}

MOTIF ${memeMotifName} ${memeMotifAlt}

letter-probability matrix: alength= ${memeMatrixALength} w= ${memeMatrixW} nsites= ${memeMatrixNSites} E= ${memeMatrixEValue} 
${memeMatrixFrequencies}`);
    });
    
    
    /*
      Locations
    */
    //console.log("sequences_id_to_attr", sequences_id_to_attr);
    let locations = { p_threshold : 0, sites : [] };
    if (!o.MEME || !o.MEME.scanned_sites_summary || !o.MEME.scanned_sites_summary._attributes || !o.MEME.scanned_sites_summary.scanned_sites) {
      throw new Error("MEME object does not define scanned sites data");
    }
    locations.p_threshold = o.MEME.scanned_sites_summary._attributes.p_thresh;
    o.MEME.scanned_sites_summary.scanned_sites.forEach((ss, ssi) => {
      //console.log("-ssi", ssi);
      if (!ss._attributes || !ss._attributes.sequence_id || !ss._attributes.pvalue) {
        //console.log("-ssi XXX", ssi);
        throw new Error("MEME object scanned sites data object lacks required attributes");
      }
      //console.log("+ssi", ssi);
      
      let scanned_sites = [];
      let motif_sites = [];
      if (parseInt(ss._attributes.num_sites) !== 0) {
        //console.log("looking in scanned_site parameter...");
        if (ss.scanned_site) {
          // scanned_site property can be an Object or Array
          if (Array.isArray(ss.scanned_site)) {
            ss.scanned_site.forEach((ssss, ssssi) => {
              scanned_sites.push({
                motif_idx: motifs_id_to_attr[ssss._attributes.motif_id].idx,
                motif_id: ssss._attributes.motif_id,
                motif_name: motifs_id_to_attr[ssss._attributes.motif_id].name,
                motif_alt: motifs_id_to_attr[ssss._attributes.motif_id].alt,
                strand: (ssss._attributes.strand === "plus") ? "+" : "-",
                position: parseInt(ssss._attributes.position),
                p_value: Number(ssss._attributes.pvalue),
              });
            });
          }
          else {
            scanned_sites.push({
              motif_id: ss.scanned_site._attributes.motif_id,
              motif_idx: motifs_id_to_attr[ss.scanned_site._attributes.motif_id].idx,
              motif_name: motifs_id_to_attr[ss.scanned_site._attributes.motif_id].name,
              motif_alt: motifs_id_to_attr[ss.scanned_site._attributes.motif_id].alt,
              strand: (ss.scanned_site._attributes.strand === "plus") ? "+" : "-",
              position: parseInt(ss.scanned_site._attributes.position),
              p_value: Number(ss.scanned_site._attributes.pvalue),
            });
          }
        }
        //console.log("looking in motifs...");
        o.MEME.motifs.motif.forEach((m, mi) => {
          m.contributing_sites.contributing_site.forEach((cs, csi) => {
            if (cs._attributes.sequence_id === ss._attributes.sequence_id) {
              const site_letters = cs.site.letter_ref.map(d => d._attributes.letter_id);
              const site_sequence = site_letters.join('');
              motif_sites.push({
                motif_idx: mi,
                motif_id: m._attributes.id,
                motif_name: m._attributes.name,
                motif_alt: m._attributes.alt,
                strand: (cs._attributes.strand === "plus") ? "+" : "-",
                position: parseInt(cs._attributes.position),
                p_value: Number(cs._attributes.pvalue),
                left_flank: (cs.left_flank._text) ? cs.left_flank._text : "",
                sites: site_sequence,
                right_flank: (cs.right_flank._text) ? cs.right_flank._text : ""
              });
            }
          });
        });
      }
      
      const seq_attr = sequences_id_to_attr[ss._attributes.sequence_id];
      const seq_idx = (seq_attr && (typeof seq_attr.index !== "undefined")) ? seq_attr.index : "";
      const seq_name = (seq_attr && seq_attr.name) ? seq_attr.name : ss._attributes.sequence_id;
      const seq_length = (seq_attr && seq_attr.length) ? seq_attr.length : 0;
      let lo = {
        'sequence_id' : ss._attributes.sequence_id,
        'sequence_idx' : seq_idx,
        'sequence_name' : seq_name,
        'sequence_length' : seq_length,
        'p_value' : Number(ss._attributes.pvalue),
        'num_sites' : parseInt(ss._attributes.num_sites),
        'scanned_sites' : scanned_sites,
        'motif_sites' : motif_sites
      };
      //console.log("+lo", lo);
      locations.sites.push(lo);
    });
    locations.sites.sort((a, b) => (a.p_value > b.p_value) ? 1 : -1);
    //console.log(JSON.stringify(locations, null, 2));
    
    const motifsResult = {
      items: items,
      attributes: attributes,
      alphabet: memeAlphabet,
      assembly: assembly,
      model: model,
      sites: sites,
      locations: locations
    };
    return motifsResult;
  }

  render () {
    return (
      <div className="App">
        <div className="parent-container-navigation">
          {(this.state.dataState === 'loading') ? 
          <div className="center-div">
            <Loader
              type="Oval"
              color="#000000"
              height={100}
              width={100}               
              />
            <div style={{marginTop:"10px"}}>{this.state.dataStateMessage}...</div>
          </div> :
          <div className="left-div">
            <ViewPanelV3
              key={this.state.viewPanelKey}
              uuid={this.state.uuid}
              description={this.state.description}
              dataState={this.state.dataState}
              assembly={this.state.assembly}
              model={this.state.model}
              htmlURL={this.state.htmlURL}
              textURL={this.state.textURL}
              xmlURL={this.state.xmlURL}
              archiveURL={this.state.archiveURL}
              metadataURL={this.state.metadataURL}
              viewPanelKey={Date()}
              memeXML={this.state.memeXML}
              memeJSON={this.state.memeJSON}
              memeJSONText={this.state.memeJSONAsText}
              memeDataAvailable={this.state.memeDataAvailable}
              memeTrainingSequences={this.state.memeTrainingSequences}
              memeMotifs={this.state.memeMotifs}
              jobMetadata={this.state.jobMetadata}
              fimoManifest={this.state.fimoManifest}
              />
          </div>}
        </div>
      </div>
    );
  }
}

export default ViewV2;